<script lang="ts">
    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean = false;
</script>

<button class="btn-main dont-break" class:showIcon on:click {disabled}>
    {text}
    {#if showIcon}
        <icon></icon>
    {/if}
</button>

<style>
    .btn-main {
        min-width: 120px;
        background-color: var(--analytics-red);
        color: #ffffff;
        cursor: pointer;
        border: 1px solid var(--analytics-red);
        border-radius: 5px;
        height: 27px;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 10px;
        margin: 0 6px;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main icon {
        background-image: url('Icons/svg/navigate_next_FILL0_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 0px center;
        background-size: 24px;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 0 10px;
        margin: 0 10px;
        opacity: 0.6;
    }
    /*.btn-main:hover {*/
    /*    opacity: 0.8;*/
    /*    transition: 0.2s;*/
    /*}*/
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
        border: 1px solid var(--automapa-grey-dark);
    }
</style>
